import { render, staticRenderFns } from "./NGNDetailModal.vue?vue&type=template&id=70359cca&scoped=true&"
import script from "./NGNDetailModal.vue?vue&type=script&lang=js&"
export * from "./NGNDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./NGNDetailModal.vue?vue&type=style&index=0&id=70359cca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70359cca",
  null
  
)

export default component.exports